module.exports = __webpack_public_path__ + "media/images/iconNavMenu-c4239c689f7e50c1c253891537f8f2f6.png";